export default __webpack_public_path__ + "static/media/etapa1.7cefa7fe.png";